module.exports = __webpack_public_path__ + "img/categories.9512a4eb.svg";